import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import FieldsetList from '../FieldSetList';

import { getProviderInfoFieldsetList } from '../utils/getInfoFieldset';

import { enhance } from './enhance';

class ProviderInfo extends PureComponent {
  render() {
    const { canEdit, saveProvider } = this.props;

    return (
      <div styleName="content content--profile content--info">
        <div styleName="info">
          <div styleName="common">
            <FieldsetList
              fieldSetList={getProviderInfoFieldsetList(this.props)}
              onSave={saveProvider}
              disabled={!canEdit}
              canEdit={canEdit}
            />
          </div>
        </div>
      </div>
    );
  }
}

ProviderInfo.propTypes = {
  canEdit: PropTypes.bool,
  saveProvider: PropTypes.func,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
};

export default enhance(ProviderInfo);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/ProviderInfo/index.jsx